import React from "react"
import styled from "@emotion/styled"
import Section from "src/components/Section"
import TextLockup from "src/components/TextLockup"
import Grid from "src/components/Grid"
import { mq, globals } from "src/styles"

const Wrapper = styled(Section)`
  ${({ alignment }) =>
    alignment !== "right" &&
    `
    text-align: ${alignment};
  `}
  ${({ extraPadding }) =>
    extraPadding
      ? `
    > div {
      ${globals.verticalSpacing("padding-top", 0.5)}
      ${globals.verticalSpacing("padding-bottom", 0.5)}
    }
  `
      : ""}
  h1, h2, h3, h4, h5, h6, p, blockquote, ol, ul, dl {
    ${({ alignment }) =>
      alignment === "center" &&
      `
      margin-left: auto;
      margin-right: auto;
    `}
  }
  ${({ newStyle }) =>
    newStyle
      ? `.text-new {
        max-width: 710px;
      }`
      : `
        h1,
        h2 {
          max-width: 12em;
        }
        h3 {
          max-width: 18em;
        }
        h4,
        h5 {
          max-width: 24em;
        }
        h6 {
          max-width: 16em;
        }
        p {
          max-width: 36em;
        }
        ol,
        ul,
        dl,
        blockquote {
          max-width: 32em;
        }
  `}
  ${({ vertical }) =>
    `
    ${globals.verticalSpacing("padding-top", vertical)}
    ${globals.verticalSpacing("padding-bottom", vertical)}
  `}
  ${({ horizontal }) =>
    `
    ${globals.verticalSpacing("padding-left", horizontal)}
    ${globals.verticalSpacing("padding-right", horizontal)}
  `}
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => (hideMobile && "display: none")}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => (hideDesktop && "display: none")}
  }
`

const TextSection = ({
  className,
  nextTheme,
  prevTheme,
  theme,
  spacing,
  text,
  headline,
  headlineSize,
  headlineElement,
  hideMobile,
  hideDesktop,

  textSize,
  actions,
  alignment = "center",
  isFirstSection,
  extraPadding = false,
  entranceDelay,
  id,
}) => {
  if (!headline && !text && !text?.eyebrow && !actions) {
    return false
  }

  if (!alignment || alignment === null) {
    alignment = "left"
  }

  return (
    <Wrapper
      className={className}
      prevTheme={prevTheme}
      setTheme={theme}
      nextTheme={nextTheme}
      alignment={alignment}
      isFirstSection={isFirstSection}
      id={id}
      extraPadding={extraPadding}
      newStyle={text?.newStyle}
      vertical={spacing?.vertical}
      horizontal={spacing?.horizontal}
      hideMobile={hideMobile}
      hideDesktop={hideDesktop}
    >
      <Grid small="1 [12] 1">
        <TextLockup
          eyebrow={text?.eyebrow}
          text={text?._rawText || text}
          newStyle={text?.newStyle}
          headline={headline}
          headlineSize={headlineSize}
          headlineElement={headlineElement}
          textSize={textSize}
          actions={actions}
          theme={theme}
          alignment={alignment}
          entranceDelay={entranceDelay}
        />
      </Grid>
    </Wrapper>
  )
}

export default TextSection
